import {Component, Input, OnInit} from '@angular/core';
import {LoadingController, ModalController} from '@ionic/angular';
import {AddContactPage} from '../add-contact/add-contact.page';
import {DocumentModel} from '../../models/document.model';
import {RefreshdatabaseService} from '../../services/database/refreshdatabase.service';
import {TestConnectionService} from '../../services/test-connection.service';
import {GeneralService} from '../../services/general.service';
import {ActionModel} from '../../models/action.model';
import {StateManagerService} from '../../services/state-manager.service';
import { BinLocationModel } from 'src/app/models/bin-location.model';
import { CollectionsNames } from 'src/app/definitions/collections-names';
import { ConfigurationService } from 'src/app/services/configuration.service';

@Component({
    selector: 'app-select-bin-location',
    templateUrl: './select-bin-location.page.html',
    styleUrls: ['./select-bin-location.page.scss'],
})
export class SelectBinLocationPage implements OnInit {

    @Input() document: DocumentModel;
    @Input() action: ActionModel;
    binLocationList: BinLocationModel[] = [];
    queryText = '';

    constructor(public modalController: ModalController,
                private loadingController: LoadingController,
                private refreshDB: RefreshdatabaseService,
                private testConnection: TestConnectionService,
                private generalService: GeneralService,
                private stateManager: StateManagerService,
                private collectionNames: CollectionsNames,
                private config: ConfigurationService) {
    }

    async ngOnInit() {
        await this.populateBinLocationList();
    }

    async ionViewDidEnter() {
    }

    async populateBinLocationList() {
        this.binLocationList = [];
        if (this.document) {
            this.binLocationList = await this.stateManager.getCollection( this.collectionNames.BINLOCATIONS );

        }

        console.log(this.binLocationList);

        // strip empty locationTags
        this.binLocationList = this.binLocationList.filter(elem => {
            return elem.locationTag;
        });

        // strip other locations
        this.binLocationList = this.binLocationList.filter(elem => {
            return elem.location === this.config.getConfiguration().selectedDepot;
        });

        this.binLocationList.sort((a, b) => (a.locationTag.toLowerCase() > b.locationTag.toLowerCase()) ? 1 : -1);
    }

    fetchBinLocations(event) {
        this.testConnection.pingServer().then(() => {
            this.refreshDB.refreshBinLocations().then(() => {
                this.populateBinLocationList();
                event.target.complete();
            });
        }).catch(err => {
            event.target.complete();
            this.generalService.createToast('No connection to the server');
        });
    }
}
